import type { SailPlotExtensionContext } from "@heiselanalytics/sailplot";
import { ChangelogContent } from "../components/ChangelogContent";
import { PageActions } from "./PageActions";

export function ChangelogPage({
  language,
  navigate,
}: SailPlotExtensionContext) {
  return (
    <article className="platform-page platform-reference-page platform-changelog-page">
      <ChangelogContent language={language} />
      <PageActions language={language} navigate={navigate} />
    </article>
  );
}
